@if (dataSource.length) {
    <div class="mt-24 w-100 overflow-x-scroll" fxLayout="column" fxFlex style="overflow-y: hidden;">
        <af-table class="w-100"
                  [dataSource]="dataSource"
                  [enableScroll]="false"
                  [enableStickyHeader]="false"/>
    </div>
} @else {
    <ui-kit-empty-state class="mt-24 w-100"
                        icon="ic_empty_state_no_data"
                        [title]="'i18n_af_emptyStateTitleNoData'"
                        subtitle="i18n_af_emptyStateSubtitleNoData"
                        backgroundColor="dark"/>
}
